export enum MfaPolicyEnum {
    All = 'all',
    Partial = 'partial',
    Optional = 'optional',
}
